var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconeAtencao(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 40,
    viewBox: "0 0 42 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "IconeAtencao",
    transform: "translate(-133 -43)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pol\\xEDgono_1",
    "data-name": "Pol\\xEDgono 1",
    d: "M21,0,42,36H0Z",
    transform: "translate(133 43)",
    fill: "#fdeb08"
  }), /*#__PURE__*/React.createElement("text", {
    id: "_",
    "data-name": "!",
    transform: "translate(154 77)",
    fill: "#fff",
    fontSize: 32,
    fontFamily: "Ubuntu-Bold, Ubuntu",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -4,
    y: 0
  }, "!")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeAtencao);
export default __webpack_public_path__ + "static/media/IconeAtencao.295cdd87bb0a2b2b1b0b8b2061ea04d4.svg";
export { ForwardRef as ReactComponent };